<template>
  <NuxtErrorBoundary>
    <template #default>
      <Popper
        v-bind="$attrs"
        ref="popper"
      >
        <slot></slot>
        <template #content="contentData">
          <div @click="onContentClick(contentData)">
            <slot
              name="content"
              v-bind="contentData"
            ></slot>
          </div>
        </template>
      </Popper>
    </template>
    <template #error>
      <span></span>
    </template>
  </NuxtErrorBoundary>
</template>

<script setup lang="ts">
import { onClickOutside } from "@vueuse/core";
import type Popper from "vue3-popper/dist/popper.esm";

interface Props {
  closeOnClick?: boolean;
}
type Emits = (e: "reset") => void;

const props = defineProps<Props>();
const emits = defineEmits<Emits>();
const attrs = useAttrs();

const popper = ref<InstanceType<typeof Popper>>();

onClickOutside(popper, () => emits("reset"));
function onContentClick(popperSlot: unknown) {
  if (!props.closeOnClick || !attrs.interactive) return;
  (popperSlot as { close: () => void }).close();
}
</script>

<script lang="ts">
export default {
  inheritAttrs: false,
};
</script>

<style scoped lang="scss">
:deep(.popper) {
  z-index: 50 !important;
}
</style>
